// import React, { useState, useEffect } from "react";
// import { Grid, Text, Spinner, Alert, AlertIcon } from "@chakra-ui/react";
// import { BASE_URL } from "../../../Globalapi/Globalapi";
// import axios from "axios";

// const Component_Teacher_Bus = () => {
//   const [busData, setBusData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const staffId = sessionStorage.getItem("staff_id"); // Example teacher ID
//     const schoolId = sessionStorage.getItem("school_id"); // Example school ID

//     const fetchBusData = async () => {
//       try {
//         console.log("Fetching bus data...");

//         const response = await fetch(`${BASE_URL}/staff/bus/bus_details.php`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             teacher_id: staffId, // Correct key based on PHP code
//             school_id: schoolId, // Correct key based on PHP code
//           }),
//         });
//         const data = await response.json();
//         console.log("Bus data response:", data);

//         // Check if the response is successful
//         if (!response.ok) {
//           setError("Failed to fetch bus data.");
//           setBusData(null);
//           return;
//         }

//         // Check for success and handle accordingly
//         if (data.success) {
//           setBusData(data.data);
//           setError(null); // Clear error if data is successfully fetched
//         } else {
//           setBusData(null);
//           setError("No bus details found.");
//         }
//       } catch (err) {
//         console.error("Error occurred:", err);
//         setError("An error occurred while fetching the bus data.");
//         setBusData(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     // Call the function to fetch bus data
//     fetchBusData();
//   }, []);

//   // Loading spinner while fetching data
//   if (loading) {
//     return <Spinner size="xl" />;
//   }

//   // Error alert if there is any error fetching data
//   if (error) {
//     return (
//       <Alert status="error">
//         <AlertIcon />
//         {error}
//       </Alert>
//     );
//   }

//   // If no bus data is found
//   if (!busData) {
//     return (
//       <Text fontSize="lg" fontWeight="bold" textAlign="center">
//         No Bus Found
//       </Text>
//     );
//   }

//   // Render bus data if available
//   return (
//     <div>
//       <Grid
//         templateColumns="repeat(2, 1fr)"
//         gap={6}
//         alignItems="baseline"
//         ml={6}
//         color="black"
//       >
//         <Text fontWeight="bold" fontSize="xl" gridColumn="span 2">
//           Bus Information
//         </Text>

//         {busData.start_place && (
//           <Text fontSize="lg">Departure: {busData.start_place}</Text>
//         )}
//         {busData.end_place && (
//           <Text fontSize="lg">Destination: {busData.end_place}</Text>
//         )}

//         {busData.trip === "One way" && busData.pickup_location_name && (
//           <Text fontSize="lg">
//             Pickup Point: {busData.pickup_location_name}
//           </Text>
//         )}
//         {busData.trip === "One way" && busData.drop_location_name && (
//           <Text fontSize="lg">Drop Point: {busData.drop_location_name}</Text>
//         )}
//         {busData.trip !== "One way" && (
//           <>
//             <Text fontSize="lg">
//               Pickup Point: {busData.pickup_location_name}
//             </Text>
//             <Text fontSize="lg">Drop Point: {busData.drop_location_name}</Text>
//           </>
//         )}
//         {/* {busData.monthly_bus_fee && (
//           <Text fontSize="lg">Bus Fees: {busData.monthly_bus_fee}</Text>
//         )} */}
//       </Grid>
//     </div>
//   );
// };

// export default Component_Teacher_Bus;

import React, { useState, useEffect } from "react";
import {
  Box,
  Text,
  Spinner,
  Alert,
  AlertIcon,
  SimpleGrid,
  VStack,
  Heading,
  Icon,
  Flex,
  Divider, 
} from "@chakra-ui/react";
import {
  FaBus,
  FaMapMarkerAlt,
  FaRoute,
  FaArrowCircleRight,
  FaArrowCircleLeft,
} from "react-icons/fa";
import { BASE_URL } from "../../../Globalapi/Globalapi";
// import axios from "axios";

const DetailItem = ({ icon, label, value, isSpecial }) => (
  <Flex
    align="center"
    gap={3}
    p={2}
    bg={isSpecial ? "teal.50" : "gray.50"} 
    borderRadius="md"
  >
    <Icon as={icon} color={isSpecial ? "teal.700" : "teal.500"} w={5} h={5} />
    <VStack align="start" spacing={0}>
      <Text fontSize="xs" color="gray.600" fontWeight="semibold">
        {label}
      </Text>
      <Text fontWeight="bold" fontSize="md" color="gray.800">
        {value || "N/A"}
      </Text>
    </VStack>
  </Flex>
);

const Component_Teacher_Bus = () => {
  const [busData, setBusData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const staffId = sessionStorage.getItem("staff_id");
    const schoolId = sessionStorage.getItem("school_id");

    const fetchBusData = async () => {
      try {
        if (!staffId || !schoolId) {
          setError("Staff ID or School ID not found.");
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}/staff/bus/bus_details.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            teacher_id: staffId,
            school_id: schoolId,
          }),
        });
        const data = await response.json();

        if (!response.ok) {
          setError("Failed to fetch bus data.");
          setBusData(null);
          return;
        }

        if (data.success) {
          setBusData(data.data);
          setError(null);
        } else {
          setBusData(null);
          setError("No bus details found.");
        }
      } catch (err) {
        console.error("Error occurred:", err);
        setError("An error occurred while fetching the bus data.");
        setBusData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchBusData();
  }, []);

  // Loading spinner while fetching data
  if (loading) {
    return (
      <Box p={5} textAlign="center" width="100%">
        <Spinner size="xl" color="teal.500" />
      </Box>
    );
  }

  // Error alert if there is any error fetching data
  if (error && busData === null) {
    return (
      <Box
        // p={5}
        bg="white"
        // borderRadius="lg"
        // boxShadow="sm" 
        // borderWidth="1px"
        // borderColor="gray.200"
        width={{ base: "100%", md: "350px", lg: "400px" }}
      >
        <Heading size="md" mb={2} color="gray.600">
          Bus Information
        </Heading>
        <Alert status="warning" borderRadius="md">
          <AlertIcon />
          {error}
        </Alert>
      </Box>
    );
  }

  // Render bus data if available
  return (
    <Box
      // p={5} 
      bg="white"
      // borderRadius="md" 
      // boxShadow="lg" 
      // borderWidth="1px" 
      // borderColor="gray.100" 
      width={{ base: "100%", md: "350px", lg: "400px" }}
    >
      <Heading
        size="md"
        color="teal.600"
        mb={2}
        display="flex"
        alignItems="center"
      >
        <Icon as={FaBus} mr={3} w={6} h={6} color="teal.500" />
        Bus Route Details
      </Heading>
      <Divider mb={4} borderColor="gray.200" />
      <SimpleGrid
        columns={2}
        spacingY={4}
        spacingX={4}
      >
        {/* 1. Departure */}
        {busData.start_place && (
          <DetailItem
            icon={FaArrowCircleRight} 
            label="Departure"
            value={busData.start_place}
            isSpecial={true}
          />
        )}

        {/* 2. Destination */}
        {busData.end_place && (
          <DetailItem
            icon={FaArrowCircleLeft} 
            label="Destination"
            value={busData.end_place}
            isSpecial={true} 
          />
        )}

        {/* 3. Pickup Point */}
        {(busData.trip === "One way" && busData.pickup_location_name) ||
        busData.trip !== "One way" ? (
          <DetailItem
            icon={FaMapMarkerAlt}
            label="Pickup Point"
            value={busData.pickup_location_name}
          />
        ) : null}

        {/* 4. Drop Point */}
        {(busData.trip === "One way" && busData.drop_location_name) ||
        busData.trip !== "One way" ? (
          <DetailItem
            icon={FaMapMarkerAlt}
            label="Drop Point"
            value={busData.drop_location_name}
          />
        ) : null}

        {/* Optional: Bus Fees */}
        {/* {busData.monthly_bus_fee && (
          <DetailItem 
            icon={FaMoneyBillWave} 
            label="Monthly Fees" 
            value={`₹${busData.monthly_bus_fee}`} 
            isSpecial={false}
          />
        )} */}
      </SimpleGrid>
    </Box>
  );
};

export default Component_Teacher_Bus;
